// extracted by mini-css-extract-plugin
export default {"svg":"Chart-module__svg--CS2hB","dateRow":"Chart-module__dateRow--YIlK2"};